import { render } from "./customPaging.vue?vue&type=template&id=24b79a30&scoped=true"
import script from "./customPaging.vue?vue&type=script&lang=js"
export * from "./customPaging.vue?vue&type=script&lang=js"

import "./customPaging.vue?vue&type=style&index=0&id=24b79a30&scoped=true&lang=css"

import exportComponent from "/Users/dudgh/git/project/fognet/admin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b79a30"]])

export default __exports__